<script setup lang="ts">
import { onMounted, ref } from 'vue'

const mrBirdActive = ref(false);

const emit = defineEmits(['closeMrBird']);

const closeMrBird = () => {
  mrBirdActive.value = false;
  setTimeout(() => {
    emit('closeMrBird');
  }, 3000)
}

defineProps({
  message: {
    type: String,
    required: true,
  },
});

onMounted(() => {
  setTimeout(() => {
    mrBirdActive.value = true;
  }, 3000)
});
</script>

<template>
  <div
    class="mr-bird-wrap fixed bottom-0 right-0 lg:inline-block hidden"
    :class="{ 'mr-bird-active': mrBirdActive }"
  >
    <div class="motion-box relative">
      <svg
        class="w-full block"
        width="150"
        height="153"
        viewBox="0 0 150 153"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M102.642 116.159C101.675 117.691 90.467 160.049 89.2037 151.825C89.2037 145.321 95.3585 115.299 95.3585 115.299L102.642 116.159Z"
          fill="#692F14"
        />
        <path
          class="beak beak-bot relative"
          d="M22.8451 31.0947L24.5652 40.5284L26.7153 48.1345L1.77376 46.2262L13.7876 38.8083L22.8451 31.0947Z"
          fill="#DC8718"
        />
        <path
          class="beak beak-top relative"
          d="M-2.86102e-05 36.6044L22.8451 31.0947L26.1779 40.7971L-2.86102e-05 36.6044Z"
          fill="#DC8718"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M111.081 113.606C110.732 115.38 115.435 158.947 111.323 151.717C108.985 145.643 103.986 115.407 103.986 115.407L111.081 113.606Z"
          fill="#692F14"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M111.081 113.606C110.732 115.38 115.435 158.947 111.323 151.717C108.985 145.643 103.986 115.407 103.986 115.407L111.081 113.606Z"
          fill="#692F14"
        />
        <path
          d="M168.356 22.6555C156.691 36.3357 116.403 65.8732 89.9835 51.7091C62.5693 41.5766 73.2393 -3.46868 38.3803 0.213426C5.53697 4.54057 23.0068 52.623 28.3821 72.6192C39.1328 94.9269 56.522 113.499 81.4905 120.191C164.539 141.773 184.536 57.2995 168.356 22.6555Z"
          fill="#FFA720"
        />
        <path
          d="M46.3355 30.2885C45.7711 27.7352 43.2178 26.0957 40.6645 26.687C40.3958 26.7407 40.127 26.8214 39.8582 26.9289C34.6173 31.9279 44.9648 36.6045 46.3355 30.2885ZM46.7118 23.8649C37.7618 18.4896 30.2364 32.7074 40.3689 36.8732C49.8832 39.7491 54.076 25.5044 46.7118 23.8649Z"
          fill="white"
        />
        <path
          class="eye relative"
          d="M45.2872 28.1113C49.1305 31.6859 41.4169 35.6099 39.213 31.901C36.4447 27.305 42.0351 24.6711 45.2872 28.1113Z"
          fill="#060505"
        />
        <path
          class="wing relative"
          d="M43.8089 81.6767C46.3085 75.8445 53.4577 76.8658 58.6717 72.888C70.1481 64.0725 74.4215 55.7945 79.4743 52.3542C118.392 28.1652 142.608 93.6906 87.2954 93.3949C74.3677 93.3949 51.6838 92.6961 41.605 84.3912L43.8089 81.6767Z"
          fill="#FFC72B"
        />
      </svg>
    </div>
    <div class="message-bubble bg-white p-3 rounded-lg shadow absolute">
      <button
        type="button"
        class="btn btn-close-mr-bird btn-primary p-2 rounded-circle absolute top-0 right-0"
        aria-label="Close"
        @click="closeMrBird"
      >
        <i class="mi-times icon-16" />
      </button>
      <span v-html="message" />
    </div>
  </div>
</template>

<style lang="scss">
    .mr-bird-wrap {
        z-index: 9999;

        &.mr-bird-active {
          &:before {
            transform: scale(1);
            transition-delay: 0s;
          }
          .message-bubble {
            transform: scale(1) translateX(0%);
            transition-delay: .5s;
          }
          .motion-box {
            transform: translateX(0%);
            transition-delay: .5s;
          }
        }

        &:before {
            content: "";
            position: absolute;
            border-radius: 100%;
            width: 230px;
            height: 230px;
            left: 0;
            top: 0;
            background-color: $white;
            transform: scale(0);
            transition: .5s ease-in-out transform;
            transition-delay: .5s;
            box-shadow: 0 -4px 20px rgba(0, 0, 0, .25);
        }
        .message-bubble {
            z-index: 4;
            bottom: 100%;
            right: 100%;
            width: 235px;
            transform: scale(0) translateX(50%);
            transform-origin: 100% 100%;
            transition: .5s ease-in-out transform;
            transition-delay: 0s;

            .btn-close-mr-bird {
              transform: translate(50%, -50%);
            }

            &:before {
                content: "";
                position: absolute;
                border-style: solid;
                top: 100%;
                right: 6%;
                border-width: 0 23px 26px 0;
                border-color: transparent #ffffff transparent transparent;
            }
        }

        .motion-box {
          transform: translateX(100%);
          transition: .5s ease-in-out transform;
          transition-delay: 0s;

          svg {
            width: 100%;
            height: auto;
              .beak {
                  transform: rotate(0deg);
                  transform-box: fill-box;

                  &-top {
                      animation: 4s linear beakTop 4.2s forwards 1;
                      transform-origin: 100% 0%;
                  }
                  &-bot {
                      animation: 4s linear beakBot 4.2s forwards 1;
                      transform-origin: 86% 50%;
                  }
              }

              .wing {
                  transform-origin: 75% 50%;
                  transform-box: fill-box;
                  animation: 4s linear wingMotion 4.2s forwards 1;
              }

              .eye {
                  transform-box: fill-box;
                  transform: translate(-50%, -50%);
                  transform-origin: 50% 50%;
                  animation: 4s linear eyeMotion 4.2s forwards 1;
              }
          }
        }
        
        @media screen and (max-width: 600px) {
          &:before {
            width: 190px;
            height: 190px;
          }
          .motion-box {
            width: 100px;
          }
          .message-bubble {
            right: 85%;
          }
        }
    }
    @keyframes beakTop {
        0% {transform: rotate(0deg);}
        5% {transform: rotate(25deg);}
        10% {transform: rotate(0deg);}
        20% {transform: rotate(0deg);}
        23% {transform: rotate(25deg);}
        26% {transform: rotate(0deg);}
        30% {transform: rotate(25deg);}
        36% {transform: rotate(0deg);}
        40% {transform: rotate(25deg);}
        55% {transform: rotate(0deg);}
        64% {transform: rotate(25deg);}
        70% {transform: rotate(0deg);}
        73% {transform: rotate(25deg);}
        77% {transform: rotate(0deg);}
        86% {transform: rotate(25deg);}
        90% {transform: rotate(0deg);}
        92% {transform: rotate(25deg);}
        96% {transform: rotate(0deg);}
        100% {transform: rotate(0deg);}
    }

    @keyframes beakBot {
        0% {transform: rotate(0deg);}
        5% {transform: rotate(-25deg);}
        10% {transform: rotate(0deg);}
        20% {transform: rotate(0deg);}
        23% {transform: rotate(-25deg);}
        26% {transform: rotate(0deg);}
        30% {transform: rotate(-25deg);}
        36% {transform: rotate(0deg);}
        40% {transform: rotate(-25deg);}
        55% {transform: rotate(0deg);}
        64% {transform: rotate(-25deg);}
        70% {transform: rotate(0deg);}
        73% {transform: rotate(-25deg);}
        77% {transform: rotate(0deg);}
        86% {transform: rotate(-25deg);}
        90% {transform: rotate(0deg);}
        92% {transform: rotate(-25deg);}
        96% {transform: rotate(0deg);}
        100% {transform: rotate(0deg);}
    }
    @keyframes wingMotion {
        0% {transform: rotate(0deg);}
        10% {transform: rotate(25deg);}
        20% {transform: rotate(0deg);}
        23% {transform: rotate(25deg);}
        26% {transform: rotate(0deg);}
        30% {transform: rotate(25deg);}
        40% {transform: rotate(0deg);}
        64% {transform: rotate(25deg);}
        70% {transform: rotate(0deg);}
        86% {transform: rotate(25deg);}
        90% {transform: rotate(0deg);}
        92% {transform: rotate(25deg);}
        100% {transform: rotate(0deg);}
    }
    @keyframes eyeMotion {
        0% {transform: translate(-50%, -30%);}
        30% {transform: translate(0%, -30%);}
        35% {transform: translate(-50%, -20%);}
        65% {transform: translate(0%, -20%);}
        70% {transform: translate(-50%, -10%);}
        95% {transform: translate(0%, -10%);}
        99% {transform: translate(-30%, -30%);}
        100% {transform: translate(0%, 0%);}
    }
</style>